import React from "react";
import { Form } from "react-bootstrap";

// "Totals" in a section's panel: picking an items-table column adds an
// element that prints that column's total over all the item rows (split by
// unit type for quantity columns). `columns` are the table's number columns:
// [{ key, header }].
export default function ColumnTotalTool({ columns, onAdd }) {
  return (
    <div className="column-total-tool border-bottom pb-3 mb-3">
      <Form.Label className="fw-bold mb-1" htmlFor="column-total-select">Totals</Form.Label>
      <Form.Text className="text-muted d-block mb-2">
        Adds the total of an items-table column to this section. Quantities are totalled per unit type, e.g. &ldquo;BOX: 10, EA: 1&rdquo;.
      </Form.Text>
      {columns.length > 0 ? (
        <select
          id="column-total-select"
          className="form-select form-select-sm"
          value=""
          onChange={(e) => {
            if (e.target.value) onAdd(e.target.value);
          }}
        >
          <option value="">Add a total of…</option>
          {columns.map((column) => (
            <option key={column.key} value={column.key}>{column.header || column.key}</option>
          ))}
        </select>
      ) : (
        <Form.Text className="text-muted d-block">
          Add a number, currency or quantity column to the items table first.
        </Form.Text>
      )}
    </div>
  );
}
